import type { ButtonHTMLAttributes, DetailedHTMLProps, Ref, ReactNode } from "react";

import type { To, LinkProps } from "@shared/react-router-dom/react-router-dom";
import { Link } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./NoStyleButton.styles";

interface NoStyleButtonProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children?: ReactNode | Record<string, unknown>;
  innerRef?: Ref<HTMLAnchorElement | HTMLButtonElement>;
  to?: To;
}

/**
 * @deprecated Use `NoStyleButton` from `@fullscript/aviary-web` instead.
 */
const NoStyleButton = ({
  children,
  innerRef,
  to,
  type = "button",
  ...rest
}: NoStyleButtonProps) => {
  if (to) {
    return (
      <Link
        css={[styles.noStyle, rest.disabled && styles.disabled]}
        to={to}
        type={type}
        // Ideally this isn't necessary but I would need to type this using a union type of LinkProps and ButtonHTMLAttributes
        // Unfortunately, unions aren't extendable by other interfaces and so it would require updating a ton of other components to use type instead of interface
        {...(rest as unknown as Omit<LinkProps, "to">)}
        ref={innerRef as Ref<HTMLAnchorElement>}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      css={[styles.noStyle, rest.disabled && styles.disabled]}
      ref={innerRef as Ref<HTMLButtonElement>}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
};

export type { NoStyleButtonProps };
export { NoStyleButton };
